import { z } from 'zod';

export const PlanStepSchema = z.object({
  description: z
    .string()
    .describe(
      'One sentence in plain English describing what this step does and why. No JSON, no parameter names, no tool arguments.',
    ),
  tool: z
    .string()
    .optional()
    .describe(
      'Name of the tool this step invokes (e.g. "queryKnowledgeGraph", "transformDataset", "showDashboard"). Omit for pure reasoning or aggregation steps that do not call a tool.',
    ),
});

export const PlanInputSchema = z.object({
  summary: z.string().describe('One or two sentence plain-English summary of what the plan accomplishes.'),
  finalGrain: z
    .string()
    .describe(
      'The grain of the final answer, e.g. "one row per well", "a single number", "one KPI per field". The plan must collapse raw data down to this grain.',
    ),
  expectedOutput: z
    .string()
    .describe(
      'What the user will see when the plan completes, e.g. "a KPI card with total Q1 oil production" or "a chart of top 5 wells over time".',
    ),
  steps: z.array(PlanStepSchema).min(1).describe('Ordered execution steps.'),
  assumptions: z
    .array(z.string())
    .optional()
    .describe(
      'Optional assumptions the plan depends on. Surface unknowns here instead of guessing silently. If any assumption turns out false, revise the plan.',
    ),
});

export const PlanOutputSchema = z.object({
  success: z.literal(true),
  message: z.string(),
});

/** @public */
export type PlanStep = z.infer<typeof PlanStepSchema>;
/** @public */
export type PlanInput = z.infer<typeof PlanInputSchema>;
/** @public */
export type PlanOutput = z.infer<typeof PlanOutputSchema>;
